/**
 * The part of a Zod failure this reads, structural so it is not tied to one Zod generic and can
 * take the error from any `safeParse` in the panel.
 */
export type ZodParseFailure = {
  issues: readonly { code: string; path: readonly PropertyKey[] }[];
};

const ROOT_PATH_LABEL = '(root)';

/**
 * Agent and session payloads hold workspace content — tool arguments, custom field values, message
 * metadata — which has no business in third-party telemetry, so a report about one cannot carry it.
 * The field path and the kind of failure are enough to act on. A Zod issue's `message` is left behind
 * with the payload, since it can quote the value it rejected.
 */
export const describeZodIssues = ({ issues }: ZodParseFailure): string[] =>
  issues.map(({ code, path }) => `${path.length > 0 ? path.map(String).join('.') : ROOT_PATH_LABEL}: ${code}`);
